module.exports = __webpack_public_path__ + "static/media/ic-share.b77c7ded.svg";